import { render } from "./RegionalDistributionChart.vue?vue&type=template&id=11e3c150&scoped=true"
import script from "./RegionalDistributionChart.vue?vue&type=script&lang=js"
export * from "./RegionalDistributionChart.vue?vue&type=script&lang=js"

import "./RegionalDistributionChart.vue?vue&type=style&index=0&id=11e3c150&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-11e3c150"

export default script